import moment from "moment";
import { SPECIALITY_TAB } from "../../framework/tab/tabUtilsConstants";

export const columnDefs = [
  {
    headerName: "Code",
    field: "specialityId",
    width: 150,
  },
  {
    headerName: "Speciality Name",
    field: "name",
    width: 240,
  },
  {
    headerName: "Company",
    field: "company",
    width: 240,
  },
  {
    headerName: "Created Time",
    field: "createdTime",
    width: 240,
  },
  {
    headerName: "Updated Time",
    field: "updatedTime",
    width: 240,
  },
];

export const columnDefsFunctions = {
  createdTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
  updatedTime: {
    valueFormatter: (params) => {
      return moment(`${params.value}`).format("DD/MM/YYYY hh:mm A");
    },
  },
};
export const initial_state_speciality = {
  type: SPECIALITY_TAB,
  label: "Speciality Master",
  allowMultipleTabs: false,
};
